import { TextInput } from '@mantine/core'
import { IconSearch } from '@tabler/icons-react'
import { WbfPolicies } from '@workers-benefit-fund/shared-data'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import Portal from '@v2/commons/components/ResponsivePortal/ResponsivePortal.component'
import useDebounce from '@v2/commons/hooks/debounce/useDebounce'
import usePolicyVerification from '@v2/commons/hooks/policyVerification/usePolicyVerification'
import { useRouter } from '@v2/commons/utils/navigation'

const PersonSearchInput = () => {
  const router = useRouter()
  const { pathname } = useLocation()
  const [search, setSearch] = useState({ value: '', pathname })
  // Keep the entered query across search results; reset it when leaving search.
  if (search.pathname !== pathname) {
    setSearch({
      pathname,
      value: pathname.includes('/search/') ? search.value : '',
    })
  }
  const debounceSearch = useDebounce((value: string) => {
    router.push(value ? `/search/${value}` : '/leads')
  }, 600)

  useEffect(() => {
    debounceSearch.cancel()
  }, [pathname, debounceSearch])

  return (
    <Portal.Wrapper id="searchField">
      <TextInput
        data-testid="person-search-query-input"
        aria-label="Search people"
        placeholder="Search"
        leftSection={<IconSearch size={18} />}
        w="100%"
        value={search.value}
        onChange={(event) => {
          setSearch({ value: event.currentTarget.value, pathname })
          debounceSearch(event.currentTarget.value)
        }}
      />
    </Portal.Wrapper>
  )
}

const SearchField = () => {
  const isVendor = usePolicyVerification(
    WbfPolicies.is_enrollment_checker_vendors_enabled,
  )
  return isVendor ? null : <PersonSearchInput />
}

export default withErrorBoundaryAndPolicyCheck(
  SearchField,
  'is_enable_search_person_view',
  true,
)
